import { FC, createContext, useContext, useState } from "react";
import {
  LayoutAPI,
  LayoutProviderPropTypes,
  LayoutState,
  SidebarConf,
} from "./model";
import { DEFAULT_SIDEBAR_CONF } from "./constant";

const LayoutStateCtx: any = createContext(null);
const LayoutAPICtx: any = createContext(null);

export const LayoutProvider: FC<LayoutProviderPropTypes> = ({ children }) => {
  const [sideBarConf, setSidebarConf] =
    useState<SidebarConf>(DEFAULT_SIDEBAR_CONF);

  const layoutState: LayoutState = {
    sideBarConf,
  };

  const layoutAPI: LayoutAPI = {
    setSidebarConf,
  };

  return (
    <LayoutStateCtx.Provider value={layoutState}>
      <LayoutAPICtx.Provider value={layoutAPI}>
        {children}
      </LayoutAPICtx.Provider>
    </LayoutStateCtx.Provider>
  );
};

export const useLayoutState = () => {
  const stateContext: LayoutState = useContext(LayoutStateCtx);

  if (!stateContext) {
    throw new Error("useLayoutState must be used within the LayoutProvider");
  }

  return stateContext;
};

export const useLayoutAPI = () => {
  const apiContext: LayoutAPI = useContext(LayoutAPICtx);

  if (!apiContext) {
    throw new Error("useLayoutAPI must be used within the LayoutProvider");
  }

  return apiContext;
};
